<template>
  <div class="content">
  
    <div style="position: fixed;right:10px;top:300px;z-index:1000">
      <Rightnav @showsp="getshow" @runtops="runtop"></Rightnav>
    </div>
    <transition name="slide-fade">
      <div class="Mask" v-if="showquote">
        <div class="mask-main">
          <i @click="mask" class="iconfont icon-guanbi"></i>
          <Freequote></Freequote>
        </div>
      </div>
    </transition>
    <div class="banane">
      <img src="../assets/images/nav_img1.jpg" />
    </div>
    <div class="main">
      <div class="main-top">
        <div class="left bran-father">
          <img v-if="setinfo[0]" :src="setinfo[0].setimagemax" oncontextmenu="return false;"/>
          <div class="brand" >桔家云</div>
        </div>
        <div class="right">
          <div class="right-one">
            <div class="bran-father">
            <img v-if="setinfo[0]" :src="setinfo[0].setimage2max" class="right-one" oncontextmenu="return false;"/>
            <div class="brand" >桔家云</div>
            </div>
          </div>
          <div class="right-two">
            <div class="bran-father">
            <img v-if="setinfo[0]" :src="setinfo[0].setimage3max" class="right-two" oncontextmenu="return false;"/>
            <div class="brand" >桔家云</div>
        </div>
          </div>
        </div>
      </div>
      <h2 v-if="setinfo[0]">{{setinfo[0].pricelevel}}档{{setinfo[0].setname}}</h2>
      <div class="big-left">
        <div class="kitchmain" v-for="(item,index) in Kitchen" :key="index">
          <div class="Kitchentitle">
            <div class="Kitchen-left">{{item.spactname}}</div>
          </div>
          <el-table :data="item.itemdata" style="width:600px" @row-click="openDetails">
            <el-table-column prop="matgroupname" label="品类" width="150"></el-table-column>
            <el-table-column prop="uom" label="单位" width="150"></el-table-column>
            <el-table-column prop="formula" label="数量" width="150"></el-table-column>
            <el-table-column prop="vndname" label="可选品牌" width="150"></el-table-column>
          </el-table>
        </div>
      </div>
      <div style="overflow: hidden;" id="searchBar">
        <div :class="searchBarFixed === true? 'isFixed' :'product-right'">
          <div>
            <div class="r-bottom">
              <div class="other">套餐其他款式</div>
              <div class="wlmain">
                <ul>
                  <li v-for="(item,index) in mainlists" :key="index" @click="tosetmeal(item)">
                    <div class="bran-father">
                    <img :src="item.matimagemax" oncontextmenu="return false;"/><div class="brand" >桔家云</div></div>
                    <div class="liname">
                      <div class="Model">{{item.matname}}</div>
                      <div class="brands">[{{item.brand}}] {{item.matpricelevel}}档</div>
                      <span style="font-size: 9px;">{{item.matspecil}}</span>
                    </div>
                  </li>
                </ul>
                <div>
                  <el-pagination
                    :page-size="6"
                    @current-change="handlecurrentchange"
                    :current-page.sync="page"
                    background
                    layout=" prev, pager, next"
                    :total="cases.totalCount"
                  ></el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height:100px;"></div>
    <div>
      <BottomFoot></BottomFoot>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import BottomFoot from "../components/BottomFoot.vue";
import Rightnav from "../components/Rightnav.vue";
import Freequote from "../components/Freequote.vue";
import { constants } from "crypto";
import { async } from "q";
export default {
  components: {
  
    BottomFoot,
    Rightnav,
    Freequote
  },
  data() {
    return {
      nub: "2",
      showquote: false,
      current: 0,
      measure: [{ name: 1 }, { name: 2 }, { name: 2 }],
      Kitchen: [],
      setinfo: [],
      mainlists: "",
      cases: "",
      searchBarFixed: false,
      matgroup: [],
      spactid: "",
      resc: "",
      matgroupid: ""
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    //console.log("scroll",this.handleScroll)
  },
  methods: {
    handlecurrentchange(size) {
      this.page = size;
      //console.log("hhhhhhhhh",this.matgroupid);
      this.productwl();
    },
    getjson: async function() {
      let setid = this.$route.query.id;
      let resp = await this.exequy.getpack(setid);
      if (resp) {
        this.setinfo = resp.data.setinfo;
      }
      this.Kitchen = resp.data.data;
      this.spactid = this.Kitchen[0].spact_id;
      //console.log('this.spactid',this.spactid);
      //console.log("this.Kitchen", this.Kitchen);
      let data = {
        setid: setid,
        spact_id: this.spactid,
        matgroupid: this.Kitchen[0].itemdata[0].matgroupid,
        pricelevel: this.setinfo[0].pricelevel,
        limit: 6,
        page: this.page
      };
      let resc = await this.exequy.packproduct(data);
      this.cases = resc.data.data.otherMat;
      //console.log("aaa",this.cases);
      this.mainlists = this.cases.list;
      this.Kitchen.map(vl => {
        vl.itemdata.map(vs => {
          if (vs.formula == "") {
            vs.formula = vs.digit.split(".")[0];
          } else {
            vs.formula = "按面积换算";
          }
        });
      });
    },
    openDetails: async function(row, event, column) {
      this.matgroupid = row.matgroupid;
      //console.log("hhhhhhhhh", this.matgroupid);
      this.productwl();
      // let data = {
      //     setid: res,
      //     spact_id: this.spactid,
      //     matgroupid: this.matgroupid,
      //     pricelevel: this.setinfo[0].pricelevel,
      //     limit: 3,
      //     page: this.page
      //   };
      //   let resc = await this.exequy.packproduct(data);
      //   this.cases = resc.data.data.otherMat;
      //   this.mainlists = this.cases.list;
    },
    productwl: async function() {
      let res = this.$route.query.id;
      let data = {
        setid: res,
        spact_id: this.spactid,
        matgroupid: this.matgroupid,
        pricelevel: this.setinfo[0].pricelevel,
        limit: 6,
        page: this.page
      };
      let resc = await this.exequy.packproduct(data);
      this.cases = resc.data.data.otherMat;
      this.mainlists = this.cases.list;
    },
    getshow(data) {
      // console.log("data", data);
      this.showquote = data;
    },
    runtop(data) {
      document.documentElement.scrollTop = data;
    },
    getshow(data) {
      // console.log("data", data);
      this.showquote = data;
    },
    mask() {
      this.showquote = false;
    },
    addClass(index, item) {
      this.current = index;
    },
    tosetmeal(item) {
      //console.log("kkkk", item.matid);
      this.$router.push({
        name: "ProductDetails",
        query: { resl: item.matid }
      });
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop);
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      let scrollBottom = scrollHeight - scrollTop - windowHeight;
      //console.log(scrollBottom);
      // console.log(scrollHeight);
      if (scrollTop > 900 && scrollBottom > 95) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
    }
  },
  created: async function() {
    let self = this;
    self.getjson();
    // self.getjson2();
  },
  watch: {
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style <style lang="less" scoped>
.content {
  width: 100%;
}
.head {
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}
.banane {
  width: 100%;
  height: 340px;
  
}
.banane img {
  width: 100%;
  height: 100%;
}
.main {
  width: 80%;
  margin: 0 auto;
  margin-top: 30px;
  overflow: hidden;
}
.main-top {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}
.main .left {
  float: left;
  width: 62%;
}
.main .left img {
  width: 77%;
}
.main .right {
  width: 38%;
  float: left;
  overflow: hidden;
}
h2 {
  text-align: left;
  margin-left: 22%;
  line-height: 0;
}
.wlmain .bran-father{
  position: relative;
}
.wlmain .brand{
 width:70px; 
 height:25px; 
 background:#b31d25;
 position:absolute;
 top: 0px;
 right: 0px;
 color: #fff;
 line-height: 25px;
 font-size: 16px;
}
.right .bran-father{
  position: relative;
}
.right .brand{
 width:80px; 
 height:30px; 
 background:#b31d25;
 position:absolute;
 top: 0px;
 right: 13.5%;
 color: #fff;
 line-height: 30px;
 font-size: 18px;
}
.bran-father{
  position: relative;
}
.brand{
 width:15%; 
 height:50px; 
 background:#b31d25;
 position:absolute;
 top: 0px;
 right: 12%;
 color: #fff;
 line-height: 50px;
 font-size: 25px;
}
.right-one,
.right-two {
  width: 73%;
}
.right-one {
  margin-bottom: 2%;
}
.right-one img,
.right-two img {
  height: 100%;
  overflow: hidden;
}
.Bigmap {
  width: 100%;
  height: 30rem;
}
.Bigmap img {
  width: 80%;
  height: 24rem;
}
.Smallmap {
  width: 100%;
}
.classred {
  border: 1px solid #b31d25;
}
.Price {
  width: 100%;
  height: 4rem;
  line-height: 4rem;
  background: #f2f2f2;
  font-size: 25px;
  color: #d9332e;
}
.info {
  width: 50%;
  margin-right: 10%;
  float: right;
  text-align: left;
}
.kitchmain {
  width: 600px;
  margin-top: 2rem;
  overflow-x: hidden;
}
/* .kitchmain:nth-child(2n+1){
  margin-left: 2%;
} */
.Kitchentitle {
  width: 600px;
  overflow-x: hidden;
}
.Kitchen-left {
  width: 600px;
  float: left;
  height: 3rem;
  line-height: 3rem;
  background: #b31d25;
  color: #fff;
  font-size: 20px;
  overflow-x: hidden;
}
.Kitchen-main ul li {
  width: 100%;
  list-style: none;
  float: left;
  width: 250px;
  margin-left: 10px;
  margin-top: 20px;
  border-bottom: 1px solid #ddd;
  overflow-x: hidden;
}
// .kitchmain >>> .el-table--scrollable-x .el-table__body-wrapper {
//   overflow-x: hidden;
// }

.Kitchen-main ul li img {
  width: 100%;
  height: 100%;
}
.big-left {
  width: 60%;
  float: left;
}
.product-right {
  background: white;
  position: fixed;
  top: 940px;
  // left: 1150px;
  border-radius: 15px;
  margin-top: 2rem;
  // float: left;
  width: 600px;
  border: 1px solid #ddd;
  z-index: 999;
}
#searchBar {
  .isFixed {
    width: 35%;
    background: white;
    border: 1px solid #ddd;
    position: fixed;
    top: 100px;
    z-index: 999;
    margin-left: 2%;
  }
}
.r-bottom {
  width: 100%;
  height: 65%;
}
.top-img {
  margin-left: 5%;
  width: 35%;
  height: 100%;
}
.top-msg {
  margin-left: 5%;
  text-align: left;
  width: 50%;
}
.top-img,
.top-msg {
  float: left;
}
.other {
  line-height: 30px;
  height: 100%;
  background: #b31d25;
  color: white;
  float: left;
  width: 5%;
}
.wlmain {
  float: left;
  width: 95%;
  height: 100%;
}
.wlmain ul {
  overflow: hidden;
  padding-inline-start: 0px;
  margin-left: -3%;
  margin: 0 auto;
}
.wlmain ul li {
  list-style: none;
  width: 32%;
  height: 280px;
  float: left;
  margin-left: 1%;
  margin-top: 1rem;
  border: 1px solid #ddd;
  box-sizing: border-box;
  padding: 5px;
  border-radius: 7px;
}
.wlmain ul li img {
  width: 100%;
}
.Model {
  font-size: 12px;
  color: #000;
}
.brands {
  font-size: 14px;
  color: #c42d28;
  padding-top: 2px;
  padding-bottom: 6px;
}
.top-img img {
  width: 100%;
  margin-top: 5px;
  height: 80%;
}
.liname {
  font-size: 14px;
  text-align: left;
  color: #827c7c;
}
.blockleft {
  width: 24.8%;
  float: left;
  height: 134px;
  line-height: 134px;
  background: #f2f2f2;
  border-left: 1px solid #fff;
}
.blockleft img {
  width: 100%;
  height: 100%;
}
.Mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
}
.mask-main {
  border-radius: 15px;
  text-align: center;
  width: 50%;
  height: 60%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background-color: white;
  z-index: 10000;
}
.icon-guanbi {
  font-size: 25px;
  position: absolute;
  right: 11px;
  top: 5px;
  line-height: normal;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.el-table__body,
.el-table__footer,
.el-table__header {
  margin: 0 auto;
}
// .kitchmain >>> .el-table--scrollable-x .el-table__body-wrapper {
//   overflow-x: hidden;
// }
.el-pagination {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
</style>
